<angular-editor
  #editor
  matInput
  [config]="editorConfig"
  [placeholder]="placeholderKey | locLabel"
  [ngModel]="text"
  [ngClass]="{ 'editor-invalid': hasValidationError }"
  (ngModelChange)="onTextChanged($event)"
>
  <ng-template #customButtons let-executeCommandFn="executeCommandFn">
    <ae-toolbar-set>
      <app-emoji-input (onSelect)="insertEmoji($event)"></app-emoji-input>
      <!-- ? Custom mat-select because we need to use mousedown event, because the mousedown event will be handled before the focus of another element is lost and we need this to preserve selection -->
      <mat-select class="font-select" (mousedown)="openSelectFont($event)" [ngModel]="fontName">
        <mat-option *ngFor="let font of fonts" [value]="font" (mousedown)="onSelectFont(font, $event)">
          <span [ngStyle]="{ 'font-family': font }">{{ font }}</span>
        </mat-option>
      </mat-select>
    </ae-toolbar-set>
  </ng-template>
</angular-editor>
<div align="end" class="validator-hint" appearance="outline" *ngIf="!emptyStringError && rawText.length <= maxLength">
  {{ rawText.length }} / {{ maxLength }}
</div>
<div class="validator-error" *ngIf="emptyStringError && rawText.length <= 0">{{ 'label.required' | loc }}</div>
<div class="validator-error" *ngIf="rawText.length > maxLength">
  {{ 'error.textMaxLength' | loc }} {{ rawText.length }} / {{ maxLength }}
</div>
